module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="gut-check-intro">\n    <div class="gut-check-intro__job">\n        <h3>Which job best demonstrates your <strong>' +
__e( skillName ) +
'</strong> experience?</h3>\n        <select name="job">\n            ';
 jobs.forEach(function(job) { ;
__p += '\n                <option value="' +
__e( job.reference_id ) +
'">' +
__e(job.company ) +
' - ' +
__e( job.title ) +
'</option>\n            ';
 }) ;
__p += '\n        </select>\n        <div class="gut-check-intro__button text-center">\n            <button class="btn btn-primary btn-large js-select-job">Next</button>\n        </div>\n    </div>\n    <div class="gut-check-intro__options">\n        <h3>You can also...</h3>\n        <ul class="radio-list radio-list-left">\n            <li>\n                <input type="radio" id="add-job" name="skill-options" value="' +
__e( GUT_CHECK_STEP.ADD_JOB ) +
'" />\n                <label for="add-job">Add another job for this skill</label>\n            </li>\n            <li>\n                <input type="radio" id="explain" name="skill-options" value="' +
__e( GUT_CHECK_STEP.EXPLAIN ) +
'" />\n                <label for="explain">\n                    <span>Explain ' +
__e( skillName ) +
' experience</span>\n                    <small>e.g. for skills gained outside the workplace</small>\n                </label>\n            </li>\n            <li>\n                <input type="radio" id="change-skill" name="skill-options" value="' +
__e( GUT_CHECK_STEP.CHANGE_SKILL ) +
'" />\n                <label for="change-skill">Change ' +
__e( skillName ) +
' skill level</label>\n            </li>\n        </ul>\n    </div>\n</div>\n';

}
return __p
}